<!--
  邀请好友任务规则弹窗
  结构同新股弹窗，差异：标题文案、图标（icon-invite）、只有上限说明没有备注
-->
<script lang="ts">
  import { _ as t } from "svelte-i18n";
  import BottomSheet from "./BottomSheet.svelte";
  import balloon from "../assets/images/dialog/balloon.png";
  import inviteIcon from "../assets/images/dialog/icon-invite.png";
  import underline from "../assets/images/dialog/deco-underline.png";
  import star from "../assets/images/dialog/deco-star.png";

  interface Props {
    show: boolean;
    onClose: () => void;
  }

  let { show, onClose }: Props = $props();
</script>

<BottomSheet {show} {onClose}>
  <!-- 气球：压在弹窗左上角并向上溢出 -->
  <img src={balloon} alt="" class="dlg-balloon" />

  <!-- 标题：邀请好友（金色）+ 任务规则（白色） -->
  <div class="dlg-title-wrap">
    <h2 class="dlg-title">
      <span class="dlg-title-hl">{$t("invite_rule_title_hl")}</span
      >{$t("invite_rule_title")}
    </h2>
    <img src={underline} alt="" class="dlg-title-line" />
    <img src={star} alt="" class="dlg-title-star is-right" />
    <img src={star} alt="" class="dlg-title-star is-left" />
  </div>

  <!-- 白色内容卡 -->
  <div class="dlg-card">
    <img src={inviteIcon} alt="" class="dlg-invite-icon" />

    <p class="dlg-card-title">{$t("guide_title")}</p>

    <div class="dlg-table">
      <div class="dlg-row">
        <span class="dlg-cell-left">
          <span class="dlg-cell-text">{$t("invite_tier_1")}</span>
        </span>
        <span class="dlg-cell-right">
          <span class="dlg-cell-text">{$t("invite_tier_1_code")}</span>
        </span>
      </div>
    </div>

    <p class="dlg-max">{$t("invite_max")}</p>
  </div>

  <button type="button" class="grad-btn dlg-confirm" onclick={onClose}>
    {$t("btn_confirm")}
  </button>
</BottomSheet>

<style>
  /* 气球 152x258@2x = 76x129，向上溢出弹窗顶边 */
  .dlg-balloon {
    position: absolute;
    top: -26px;
    left: -4px;
    width: 76px;
    height: 129px;
  }

  /* 顶部间距由弹窗的 padding-top 26px 提供，这里只留标题到白卡的距离 */
  .dlg-title-wrap {
    position: relative;
    padding-bottom: 6px;
    text-align: center;
  }

  /* 标题（设计稿）：20px / 700 / line-height 20px / shadow 0 2px 2px #165BFD */
  .dlg-title {
    position: relative;
    z-index: 1;
    font-size: 20px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0;
    color: #ffffff;
    text-shadow: 0 2px 2px #165bfd;
  }

  /* 高亮部分「邀请好友」：#FFDF00 */
  .dlg-title-hl {
    color: #ffdf00;
  }

  /* 标题笔画 149x18@2x = 74.5x9，压在标题右下方 */
  .dlg-title-line {
    position: absolute;
    bottom: -6px;
    left: 50%;
    width: 74.5px;
    height: 9px;
    margin-left: 25px;
  }

  /* 小星星 16x16@2x = 8x8 */
  .dlg-title-star {
    position: absolute;
    left: 50%;
    width: 8px;
    height: 8px;
  }

  .dlg-title-star.is-right {
    top: -2px;
    margin-left: 82px;
    transform: rotate(-20deg);
  }

  .dlg-title-star.is-left {
    top: 21px;
    margin-left: -91px;
    transform: rotate(15deg);
  }

  .dlg-card {
    position: relative;
    margin-top: 15px;
    padding: 12px;
    border-radius: 16px;
    background: #ffffff;
  }

  /* 邀请图标 162x144，按同比例渲染 73x65，压在白卡右上角 */
  .dlg-invite-icon {
    position: absolute;
    top: -17px;
    right: 8px;
    width: 73px;
    height: 65px;
  }

  /* 获取攻略（设计稿）：16px / 600 / line-height 24px / #003EC7 */
  .dlg-card-title {
    position: relative;
    z-index: 1;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    color: #003ec7;
  }

  /* 表格：底色 #F3FAFF，边框统一 #ABDEFF */
  .dlg-table {
    margin-top: 12px;
    border: 1px solid #abdeff;
    border-radius: 8px;
    background: #f3faff;
    overflow: hidden;
  }

  /* 行高固定 52px */
  .dlg-row {
    display: flex;
    align-items: stretch;
    height: 52px;
  }

  /* 单元格都垂直居中 */
  .dlg-cell-left,
  .dlg-cell-right {
    display: flex;
    align-items: center;
  }

  /* 左列：固定 210px，文字可换行 */
  .dlg-cell-left {
    flex: none;
    width: 210px;
    padding: 8px 15.5px;
  }

  .dlg-cell-left .dlg-cell-text {
    text-align: left;
  }

  /* 右列：占满剩余宽度，不换行 */
  .dlg-cell-right {
    flex: 1;
    min-width: 0;
    padding: 17px 28px;
    border-left: 1px solid #abdeff;
  }

  .dlg-cell-right .dlg-cell-text {
    white-space: nowrap;
  }

  /*
    表格文字（设计稿）：14px / 400 / line-height 22px / #001746
    单独一层撑满宽度，换行后每一行都能水平居中
  */
  .dlg-cell-text {
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0;
    color: #001746;
    text-align: center;
  }

  .dlg-max {
    margin-top: 12px;
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
    color: #1d1d1d;
  }

  /* 渐变底 + 1.5px 渐变描边 + 内阴影同任务按钮，见 app.css 的 .grad-btn */
  .dlg-confirm {
    width: 100%;
    height: 48px;
    margin-top: 24px;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1;
  }
</style>
